import { render, staticRenderFns } from "./Whypartner2.vue?vue&type=template&id=68a3f657&"
import script from "./Whypartner2.vue?vue&type=script&lang=js&"
export * from "./Whypartner2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports